import { FC } from "react";
import __ from "src/utils/Translations";
import useBasePath from "src/utils/hooks/useBasePath";
import { absencesAbsencesConfigurationWrite } from "src/utils/RoleBasedSecurity/permissions";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import Title from "src/Pages/Company/Absences/Title/Title";
import CalendarForm from "src/Pages/Company/Absences/Calendars/Calendar/CalendarForm";
import PermissionsAlert from "src/Pages/Company/Absences/PermissionsAlert";

const CalendarCreate: FC = () => {
  const basePath = useBasePath();
  const canWriteAbsencesConfiguration = usePermission(
    absencesAbsencesConfigurationWrite
  );

  return (
    <>
      <BreadcrumbsMui
        items={[
          {
            label: __("Nieobecności"),
            to: `${basePath}/absences`,
          },
          {
            label: __("Lista kalendarzy"),
            to: `${basePath}/absences/calendars`,
          },
          {
            label: __("Dodawanie nowego kalendarza"),
          },
        ]}
      />
      <Title
        title={__("Dodawanie nowego kalendarza")}
        subtitle={__(
          "Przestrzeń do tworzenia i zarządzania kalendarzem rocznym."
        )}
      />
      {!canWriteAbsencesConfiguration && <PermissionsAlert />}
      <CalendarForm />
    </>
  );
};

export default CalendarCreate;
